import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'petastiDoubleChamiliApostrofos';
const args = {};

export class PetastiDoubleChamiliApostrofos extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
